export default __webpack_public_path__ + "7ab6490cc98ea6da6e2df1a73faf3fd6.png";